import React, { useState, useEffect } from "react";
//import { useStyles } from "../../style";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, IconButton, Snackbar, Typography } 
from "@mui/material";
//import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import dayjs from "dayjs";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import { DownloadFormButton } from "../shared/downloadformbutton";
import { dashboardText, icon34, mainGrid, paddingbox, paddingboxeven, pcolor } from "../../style2";

export function FormsList(props) {
    //const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [result, setResult] = useState([]);
    const ls = new AccessLocalStorage();
    const [selectedForm, setSelectedForm] = useState(null);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setError("Unauthorized. No token available.");
            setLoading(false);
            return;
        }

        fetch(
            `${getApiUrl()}/patientform/getbypatient/${ls.getCurrentPatientId()}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    response.json().then(data => {
                        if (data !== null) {
                            let temp = data.filter(t => t.status === 3 || t.status === 4);
                            // If showOnly prop is provided (a list of guids), restrict results to only
                            // those forms whose id appears in the list. When showOnly is absent or
                            // empty, all status-filtered forms are shown.
                            if (props.showOnly && props.showOnly.length > 0) {
                                temp = temp.filter(t => props.showOnly.includes(t.id));
                            }
                            setResult(temp);
                        }
                    });
                } else {
                    setResult([]);

                    response.json().then(data => {
                        //console.log(data);
                        setError("An error occurred.");
                    }).catch(err => {
                        setError(err.message || "An error occurred.");
                    });
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return <Box sx={(props.fullWidth ? null : paddingbox)}>
        <Box display="flex" alignItems="center" sx={dashboardText}>
            <Box component="img" src={props.icon ? props.icon : `assets/forms.png`} sx={icon34}></Box>
            <Box mr={1}/>
             Forms
            {loading ? <span style={{ marginLeft: 10 }}><CircularProgress size={20} /></span> : null}
        </Box>
        <Box sx={{...mainGrid, marginTop: "10px", padding: "20px 30px 20px 30px" }}>
            {result.map((form, index) => {
                return <Box key={index}>
                    <Grid container sm spacing={2} alignItems="center" sx={{ pt: 2, pb: 2 }}>
                        <Grid item xs={4}>
                            <Typography style={{ fontWeight: "normal", fontSize: 16, color: "#115C71" }}>
                                {form.title}
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography style={{ fontWeight: "normal", fontSize: 16, color: "#115C71" }}>
                                Code: {form.code}
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography style={{ fontWeight: "normal", fontSize: 16, color: "#115C71" }}>Assigned - {form.assignedAt !== null ? dayjs(form.assignedAt).format("DD/MM/YYYY") : ''}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            {form.status === 3 ? <Typography style={{ fontWeight: "normal", fontSize: 16, color: "#115C71" }}>Submitted - {form.answerSubmitDate !== null ? dayjs(form.answerSubmitDate).format("DD/MM/YYYY") : ''}</Typography> : null}
                            {form.status === 4 ? <Typography style={{ fontWeight: "normal", fontSize: 16, color: "#115C71" }}>Completed - {form.answerCompleteDate !== null ? dayjs(form.answerCompleteDate).format("DD/MM/YYYY") : ''}</Typography> : null}
                        </Grid>

                        <Grid item xs={2} style={{ textAlign: "end" }}>
                            <DownloadFormButton form={form} />

                            <IconButton title="View Form" edge="end" aria-label="View" onClick={() => { setSelectedForm(form); }} style={{ marginLeft: 30, marginRight: 10 }}>
                                <VisibilityIcon style={{ color: "#FF767E" }} />
                            </IconButton>

                        </Grid>
                    </Grid>
                    <Box component="div" sx={{ marginTop:"10px", marginBottom:"6px", border: "1px solid #F1EFDF" }} />
                </Box>;
            })}
        </Box>
        {error !== "" ? <Snackbar
            open={error !== ""}
            autoHideDuration={6000}
            onClose={() => { setError("") }}
            message={error}
        /> : null}
        {selectedForm !== null ? <Dialog
            open={selectedForm !== null}
            onClose={() => { setSelectedForm(null); }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="lg"
            fullWidth={true}
        >
            <DialogTitle>
                <Grid container fullWidth>
                    <Grid item xs={11}>
                        <Typography sx={{ fontSize: "1.9rem", textAlign: "center" }} gutterBottom>{selectedForm.title}</Typography>
                    </Grid>
                    <Grid item xs={1} sx={{ textAlign: "end" }}>
                        <Button onClick={() => { setSelectedForm(null); }}>
                            <CloseIcon />
                        </Button>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <ViewForm form={selectedForm} />
            </DialogContent>
        </Dialog> : null}
    </Box>;
}


function GridTable({ gridColumns, gridRows }) {
    if (!gridColumns || !gridRows) return null;
    const sortedCols = [...gridColumns].sort((a, b) => a.order - b.order);
    const sortedRows = [...gridRows].sort((a, b) => a.order - b.order);
    return (
        <Box sx={{ overflowX: "auto", mt: 1 }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        <th style={{ border: "1px solid #b2d8e0", padding: "8px 14px", backgroundColor: "#115C71", textAlign: "left", minWidth: "160px" }}></th>
                        {sortedCols.map((col, cIdx) => (
                            <th key={cIdx} style={{ border: "1px solid #b2d8e0", padding: "8px 14px", backgroundColor: "#115C71", textAlign: "center", minWidth: "110px" }}>
                                <Typography style={{ fontSize: "0.95rem", fontWeight: "bold", color: "#fff" }}>{col.label}</Typography>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {sortedRows.map((row, rIdx) => (
                        <tr key={rIdx} >
                            <td style={{ border: "1px solid #dce8eb", padding: "8px 14px" }}>
                                <Typography style={{ fontSize: "0.95rem",  fontWeight: "500" }}>
                                {row.label}
                                </Typography>
                                <Box mb={2}></Box>
                                {(row.allowSupportAnswerText || row.supportAnswerText) && (
                                    <Typography style={{ fontSize: "0.85rem", fontStyle: "italic", color: "#555" }}>
                                        {row.supportAnswerText}
                                    </Typography>
                                )}
                            </td>
                            {sortedCols.map((col, cIdx) => {
                                const cell = row.cells && row.cells.find(c => c.columnId === col.id);
                                return (
                                    <td key={cIdx} style={{ border: "1px solid #dce8eb", padding: "8px 14px", textAlign: "center" }}>
                                        {(col.inputType === 1 || col.inputType === 2) ? (
                                            cell && cell.isSelected
                                                ? <CheckCircleOutlineIcon style={{ fontSize: "20px" }} />
                                                : <span style={{ color: "#bbb" }}>—</span>
                                        ) : (
                                            <Typography style={{ fontSize: "0.95rem", color: "#333" }}>{cell ? cell.answerText : ""}</Typography>
                                        )}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </Box>
    );
}

export function ViewForm(props) {
    const [form, setForm] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
         const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setError("Unauthorized. No token available.");
            setLoading(false);
            return;
        }
        setLoading(true);
        fetch(`${getApiUrl()}/patientform/${props.form.id}`, 
        { method: 'GET', 
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        setForm(data.form);
                    });
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }, [props]);

    if (form === null)
        return <>
            {loading ? <Box m={2} style={{ textAlign: "center" }}><CircularProgress /></Box> : null}
        </>;
    else
        return <>
            {/* Form description */}
            {form.description !== null && form.description !== "" ?
                <Box pb={2} pt={2} px={2} mb={2} style={{ backgroundColor: "#f0f8fa", borderLeft: "4px solid #115C71", borderRadius: "4px" }}>
                    <Typography style={{ fontSize: "1rem", color: "#444", fontStyle: "italic" }}>{form.description}</Typography>
                </Box> : null}

            {form.sections !== null && form.sections.map((section, sectionIndex) => (
                <Box key={sectionIndex} mb={3} style={{ border: "1px solid #c8e0e6", borderRadius: "10px", overflow: "hidden" }}>
                    {/* Section header bar */}
                    <Box style={{ backgroundColor: "#115C71", padding: "10px 16px" }}>
                        <Typography style={{ fontSize: "1.2rem", color: "#fff", fontWeight: "600" }}>{section.title}</Typography>
                    </Box>

                    <Box p={1}>
                        {section.questions !== null && section.questions.map((question, qIndex) => (
                            <Box key={qIndex} px={2} py={3} style={{ borderBottom: qIndex < section.questions.length - 1 ? "1px solid #eef5f7" : "none" }}>
                                {/* Question text */}
                                <Typography style={{ fontSize: "1.1rem", fontWeight: "600"}}>
                                    <span style={{ marginRight: "6px" }}>{question.sequence}.</span>{question.questionText}
                                </Typography>

                                <Box style={{ marginLeft: "22px", marginTop: "8px" }}>
                                    {/* Text */}
                                    {question.answerType === 1 && question.answerText !== null && question.answerText !== "" ?
                                        <Box style={{  padding: "6px 12px", borderRadius: "4px" }}>
                                            <Typography style={{ fontSize: "1rem", color: "#333" }}>{question.answerText}</Typography>
                                        </Box> : null}

                                    {/* Number / Date */}
                                    {(question.answerType === 2 || question.answerType === 3) && question.answerText !== null ?
                                        <Box style={{  padding: "6px 12px", borderRadius: "4px" }}>
                                            <Typography style={{ fontSize: "1rem", color: "#333" }}>{question.answerText}</Typography>
                                        </Box> : null}

                                    {/* Options (single / multiple / likert / yesno) */}
                                    {(question.answerType === 4 || question.answerType === 6 || question.answerType === 7) ?
                                        <Box display="flex" flexWrap="wrap" gap={1}>
                                            {question.options !== null && question.options.filter(o => o.selected).map((option, oIndex) => (
                                                <Box key={oIndex} display="inline-flex" alignItems="center" style={{ gap: "4px", padding: "4px 12px" }}>
                                                    {question.isMultipleChoice ? <CheckCircleOutlineIcon style={{ fontSize: "16px" }} /> : null}
                                                    <Typography style={{ fontSize: "0.95rem"}}>{option.display}</Typography>
                                                </Box>
                                            ))}
                                        </Box> : null}

                                    {/* Sub-questions */}
                                    {question.answerType === 5 ?
                                        <Box mt={1}>
                                            {question.questions !== null && question.questions.map((subQuestion, sqIndex) => (
                                                <Box key={sqIndex} mt={1} mb={2} pl={2} >
                                                    <Typography style={{ fontSize: "1.05rem", fontWeight: "600" }}>
                                                        {question.sequence}.{subQuestion.sequence}. {subQuestion.questionText}
                                                    </Typography>
                                                    <Box ml={2} mt={1}>
                                                        {/* Sub: Text */}
                                                        {subQuestion.answerType === 1 && subQuestion.answerText !== null && subQuestion.answerText !== "" ?
                                                            <Box style={{  padding: "6px 12px", borderRadius: "4px" }}>
                                                                <Typography style={{ fontSize: "1rem", color: "#333" }}>{subQuestion.answerText}</Typography>
                                                            </Box> : null}

                                                        {/* Sub: Number / Date */}
                                                        {(subQuestion.answerType === 2 || subQuestion.answerType === 3) && subQuestion.answerText !== null ?
                                                            <Box style={{  padding: "6px 12px", borderRadius: "4px" }}>
                                                                <Typography style={{ fontSize: "1rem", color: "#333" }}>{subQuestion.answerText}</Typography>
                                                            </Box> : null}

                                                        {/* Sub: Options */}
                                                        {(subQuestion.answerType === 4 || subQuestion.answerType === 6 || subQuestion.answerType === 7) ?
                                                            <Box display="flex" flexWrap="wrap" gap={1}>
                                                                {subQuestion.options !== null && subQuestion.options.filter(o => o.selected).map((option2, o2Index) => (
                                                                    <Box key={o2Index} display="inline-flex" alignItems="center" style={{ gap: "4px", backgroundColor: "#e0f2f7", border: "1px solid #115C71", borderRadius: "16px", padding: "4px 12px" }}>
                                                                        {subQuestion.isMultipleChoice ? <CheckCircleOutlineIcon style={{ fontSize: "16px", color: "#115C71" }} /> : null}
                                                                        <Typography style={{ fontSize: "0.95rem", color: pcolor }}>{option2.display}</Typography>
                                                                    </Box>
                                                                ))}
                                                            </Box> : null}

                                                        {/* Sub: Grid */}
                                                        {subQuestion.answerType === 8 ? <GridTable gridColumns={subQuestion.gridColumns} gridRows={subQuestion.gridRows} /> : null}
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box> : null}

                                    {/* Grid */}
                                    {question.answerType === 8 ? <GridTable gridColumns={question.gridColumns} gridRows={question.gridRows} /> : null}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            ))}

            {error !== "" ? <Snackbar
                open={error !== ""}
                onClose={() => { setError("") }}
                message={error}
            /> : null}
        </>;
}